import { defineMessages } from 'react-intl';

export default defineMessages({
  communicators: {
    id: 'cboard.components.CommunicatorToolbar.communicators',
    defaultMessage: 'Communicators'
  },
  editTitle: {
    id: 'cboard.components.CommunicatorToolbar.editTitle',
    defaultMessage: 'Edit Communicator Title'
  },
  communicatorTitle: {
    id: 'cboard.components.CommunicatorToolbar.communicatorTitle',
    defaultMessage: 'Communicator Title'
  },
  boards: {
    id: 'cboard.components.CommunicatorToolbar.boards',
    defaultMessage: 'Boards'
  },
  copyMessage: {
    id: 'cboard.components.CommunicatorToolbar.copyMessage',
    defaultMessage: 'Copied to clipboard!'
  },
  share: {
    id: 'cboard.components.CommunicatorToolbar.share',
    defaultMessage: 'Share'
  },
  tiles: {
    id: 'cboard.components.CommunicatorToolbar.tiles',
    defaultMessage: '{qty} Tiles'
  },
  editCommunicator: {
    id: 'cboard.components.CommunicatorToolbar.editCommunicator',
    defaultMessage: 'Build'
  },
  addBoardButton: {
    id: 'cboard.components.CommunicatorToolbar.addBoardButton',
    defaultMessage: 'Add Board'
  },
  defaultBoardsIconLabel: {
    id: 'cboard.components.CommunicatorToolbar.defaultBoardsIconLabel',
    defaultMessage: 'Select a featured board'
  },
  selectDefaultBoardTitle: {
    id: 'cboard.components.CommunicatorToolbar.selectDefaultBoardTitle',
    defaultMessage: 'Select a featured board'
  },
  confirmChangeHomeBoardMessage: {
    id: 'cboard.components.CommunicatorToolbar.confirmChangeHomeBoardMessage',
    defaultMessage:
      'Do you want to change your current board for the selected option? You can switch it again'
  },
  disagree: {
    id: 'cboard.components.CommunicatorToolbar.disagree',
    defaultMessage: 'disagree'
  },
  agree: {
    id: 'cboard.components.CommunicatorToolbar.agree',
    defaultMessage: 'agree'
  },
  close: {
    id: 'cboard.components.CommunicatorToolbar.close',
    defaultMessage: 'Close'
  },
  defaultBoardImageAlt: {
    id: 'cboard.components.CommunicatorToolbar.defaultBoardImageAlt',
    defaultMessage: 'Board caption'
  },
  rootBoardDescription: {
    id: 'cboard.components.CommunicatorToolbar.rootBoardDescription',
    defaultMessage:
      'Fluent board with folders containing categories of symbols. It Mulberry symbols without any color scheme.'
  },
  picSeePalBoardDescription: {
    id: 'cboard.components.CommunicatorToolbar.picSeePalBoardDescription',
    defaultMessage:
      'Fixed board with core vocabulary, distributed in 11 columns and 6 rows. It uses ARASAAC symbols and the Fitzgerald color scheme.'
  }
});
